<!--Provides options to select company, observationGroup and observationType-->
<template>
  <div class="nopads">
    <div class="row nopads">
      <!--Observation group selection-->
      <div class="col-sm-6">
          <span class="span-title">{{ $t('observation_filter.observation_group') }}</span>
          <select
              id="observationGroup"
              v-model="observationGroup"
              class="form-select form-select-sm sm-3"
              :disabled="observationGroups.length < 1"
          >
              <option :value="null">
                  {{ $t('observation_filter.select_observation_group') }}
              </option>
              <option
                  v-for="option in observationGroups"
                  :key="option.id"
                  :value="option.id"
              >
                  {{ option.name }}
              </option>
          </select>
      </div>

      <!--Observation type selection-->
      <div class="col-sm-6">
          <span class="span-title">{{ $t('observation_filter.observation_type') }}</span>
          <select
              id="observationType"
              v-model="observationType"
              class="form-select form-select-sm sm-3"
              :disabled="observationTypes.length < 1"
          >
              <option :value="null">
                  {{ $t('observation_filter.select_observation_type') }}
              </option>
              <option
                  v-for="option in observationTypes"
                  :key="option.id"
                  :value="option.id"
              >
                  {{ option.name }}
              </option>
          </select>
      </div>
    </div>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'

export default {
    name: 'ObservationFilter',
    mixins: [restApi],
    data: function () {
        return {
            loading: false,
            observationGroups: [],
            observationTypes: [],
            observationGroup: null,
            observationType: null
        }
    },
    watch: {
        company: function () {
            this.$nextTick(() => {
                this.$emit('companySet', this.company)
            })
        },
        observationGroup: function () {
            this.$nextTick(() => {
                this.observationTypes = []
                this.observationType = null
                this.$emit('observationGroupSet', this.observationGroup)
                if (this.observationGroup !== null) {
                    this.fetchObservationType()
                }
            })
        },
        observationType: function () {
            this.$nextTick(() => {
                this.$emit('observationTypeSet', this.observationType)
            })
        }
    },
    mounted: function () {
        this.fetchObservationGroup()
    },
    methods: {
        resetData: function () {
            this.observationGroup = null
            this.observationType = null
            this.observationTypes = []
        },

        fetchObservationGroup: function () {
            this.loading = true
            this.restFetchParams(this.observationGroupUrl, {company: this.company}, this.handleObservationGroup)
        },

        handleObservationGroup: function (response) {
            this.loading = false
            this.observationGroups = response.data
        },

        fetchObservationType: function () {
            this.loading = true
            this.restFetchParams(this.observationTypeUrl, {
                company: this.company,
                group: this.observationGroup
            }, this.handleObservationType)
        },

        handleObservationType: function (response) {
            this.loading = false
            this.observationTypes = response.data
        }
    }
}
</script>
